import { defineMessages } from 'react-intl';
import { AlertType } from '@alltrails/types/Alert';

export const ALERT_TYPE_ORDER = [AlertType.CLOSURE, AlertType.DANGER, AlertType.WARNING, AlertType.INFORMATION];
export const NPS_SOURCE = 1058;
export const NPS_ALERT_MESSAGES = defineMessages({
  DISABLED: {
    defaultMessage: 'This alert was created on the NPS website. You can only view it.'
  }
});
export const DESCRIPTION_MAX_LENGTH = 500;
export const ALERT_TITLE_MAX_LENGTH = 120;
